import { ChangeDetectorRef, Component, ElementRef, Input, ViewChild, ViewContainerRef } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import Hls from 'hls.js';

import { InputConverter, JSONConverter } from '../../../inputConverter';
import { DocumentSources, MapCoreDocument } from '../../../types';
import { BaseComponent } from '../../base.component';

@Component({
    selector: 'mc-gallery',
    templateUrl: './gallery.component.html',
    styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent extends BaseComponent {
    @ViewChild('videoPlayerGallery') videoPlayer: ElementRef;
    private hls: Hls;
    private video: any;

    @Input()
    currentImageIndex: number = 0;

    mediaType: 'image' | 'video';

    private _imageSources: MapCoreDocument[];
    get imageSources() {
        return this._imageSources;
    }
    @Input()
    @InputConverter(JSONConverter)
    set imageSources(value) {
        this._imageSources = JSONConverter(value);
        this.mediaType = 'image';
        this.refreshPhotos();
    }

    private _videoSource: MapCoreDocument;
    get videoSource() {
        return this._videoSource;
    }
    @Input()
    @InputConverter(JSONConverter)
    set videoSource(value: MapCoreDocument) {
        this._videoSource = JSONConverter(value);
        this.mediaType = 'video';
        setTimeout(() => { this.initializeHls(); }, 200);
        this.refreshPhotos();
    }

    get currentTitle(): string {
        return this.imageSources && this.imageSources.length > 0 && this.currentImageIndex <= this.imageSources.length && this.imageSources[this.currentImageIndex]
            ? this.imageSources[this.currentImageIndex].title
            : '';
    }

    get currentUrl(): string | SafeUrl {
        if (this.mediaType === 'image') {
            if (this.imageSources && this.imageSources.length > 0 && this.currentImageIndex <= this.imageSources.length && this.imageSources[this.currentImageIndex]) {
                const document = this.imageSources[this.currentImageIndex];
                return document.source === DocumentSources.VIDEO ? document.thumbnail : document.url;
            }
        } else {
            return this.videoSource.url || '';
        }
        return '';
    }

    get currentDescription(): string {
        return this.imageSources && this.imageSources.length > 0 && this.currentImageIndex <= this.imageSources.length && this.imageSources[this.currentImageIndex]
            ? this.imageSources[this.currentImageIndex].description
            : '';
    }

    get currentAltText(): string {
        return this.imageSources && this.imageSources.length > 0 && this.currentImageIndex <= this.imageSources.length && this.imageSources[this.currentImageIndex]
            ? this.imageSources[this.currentImageIndex].description
            : '';
    }

    get currentPosition(): string {
        return this.imageSources ? `${this.currentImageIndex + 1} of ${this.imageSources.length}` : '';
    }

    get isMultiImage(): boolean {
        return this.imageSources && this.imageSources.length > 1;
    }

    constructor(_vcr: ViewContainerRef, private readonly changeDetectorRef: ChangeDetectorRef) {
        super(_vcr);
    }

    private refreshPhotos() {
        this.changeDetectorRef.detectChanges();
    }

    previousImage() {
        if (this.currentImageIndex === 0) {
            this.currentImageIndex = this.imageSources.length - 1;
        } else {
            this.currentImageIndex -= 1;
        }
        this.refreshPhotos();
    }

    nextImage() {
        if (this.currentImageIndex === this.imageSources.length - 1) {
            this.currentImageIndex = 0;
        } else {
            this.currentImageIndex += 1;
        }
        this.refreshPhotos();
    }
    initializeHls() {
        if (this.videoSource && this.videoSource.url) {
            this.video = this.videoPlayer.nativeElement;
            const canPlayNatively = this.video.canPlayType('application/vnd.apple.mpegURL') !== '';
            if (!canPlayNatively) {
                if (this.hls) {
                    this.hls.destroy();
                }
                if (Hls.isSupported()) {
                    this.hls = new Hls();
                    this.hls.loadSource(this.videoSource.url.toString());
                    this.hls.attachMedia(this.video);
                    this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
                        this.video.muted = true; // Mute the video for autoplay to work
                        this.video.play();
                    });
                }
            } else {
                this.video.src = this.videoSource.url;
                this.video.load();
            }
        } else if (this.video) {
            this.video.pause();
        }
    }
}
